import { render, staticRenderFns } from "./HeaderNoMenu.vue?vue&type=template&id=1a413c60"
import script from "./HeaderNoMenu.vue?vue&type=script&lang=js"
export * from "./HeaderNoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports